import { createUseThemeHook, LegoTheme } from 'legos/theme';

declare module 'legos/theme' {
  interface BulkLegoTheme {
    alerts: AlertTheme;
  }
}

export interface AlertTheme {
  default: string;
  negative: string;
}

const [AlertThemeProvider, useAlertTheme] = createUseThemeHook(
  'alerts',
  (global: LegoTheme): AlertTheme => ({
    default: global.neutral.color100,
    negative: global.negative.color50
  })
);

export { AlertThemeProvider, useAlertTheme };
